module.exports = __webpack_public_path__ + "pc/img/about_solution04.a1fee6f0.jpg";